import styles from "./CategoryChip.module.css";
import MindPageLink from "../MindPageLink/MindPageLink";

function CategoryChip({
    name,
    slug,
    style,
    removeLink = false,
    placeholder = false,
    large = false,
}) {
    return placeholder ? (
        <div
            style={style}
            className={[
                "shimmer",
                styles.category_chip,
                styles.placeholder,
                large ? styles.large : "",
            ].join(" ")}
        ></div>
    ) : removeLink ? (
        <div
            style={style}
            className={[
                "category",
                slug,
                styles.category_chip,
                styles.remove_link,
                large ? styles.large : "",
            ].join(" ")}
        >
            {name}
        </div>
    ) : (
        <MindPageLink
            href={slug?.external_post_url ?? `/mind/news/category/${slug}/`}
            style={style}
            className={[
                "category",
                slug,
                styles.category_chip,
                large ? styles.large : "",
            ].join(" ")}
            target={slug?.external_post_url ? "_blank" : ""}
        >
            {name}
        </MindPageLink>
    );
}

export default CategoryChip;
